class Navigation{

	constructor() {


		this.initMainNavigationTimeline();

		// SHOW / HIDE navigation au scroll
		this.showHideNavMain();

		this.navMain = document.querySelector('.nav-main-container');
		this.initSubNavigation();

	}

	initMainNavigationTimeline(){

		// timeline burger
		this.navigationTimeline = gsap.timeline({
			onComplete: () => {
				this.mainNavOpen = true;
				this.itemNavigation.forEach( (item) => {
					if( item.classList.contains('current-menu-ancestor') && !mobileCheck.isMobile ){
						this.showSubNav(item);
						let event = new MouseEvent('customEventEnter');
						item.dispatchEvent(event);
					}
				});
			},
			onReverseComplete: () => {
				this.mainNavOpen = false;
			}
		}).pause();

		let textureBG = document.querySelector('.nav-main-texture-bg');
		let navMain = document.querySelector('.nav-main-principal');
		let navMainLevelOne = navMain.querySelectorAll('.menu-item--lev1 > a > span');
		let navSecondary = document.querySelector('.nav-main-secondary');
		let navSecondaryLevelOne = navSecondary.querySelectorAll('.menu-item--lev1 > a > span');

		this.navigationTimeline.addLabel("start", 0);
		this.navigationTimeline.to(textureBG, {
			scale: 1,
			opacity : 1,
			ease: "none",
			duration: 0.3
		},"start");
		this.navigationTimeline.addLabel("navigation", "+=0.3");
		navMainLevelOne.forEach( (item) => {
			this.navigationTimeline.to(item, {
				y: 0,
				ease: "none",
				duration: 0.07
			});
		}, "navigation");
		navSecondaryLevelOne.forEach( (item) => {
			this.navigationTimeline.to(item, {
				y: 0,
				ease: "none",
				duration: 0.07
			}, "navigation");
		});

	}

	initSubNavigation(){

		let navMainBack = document.querySelector('.nav-main-back');
		navMainBack.addEventListener('click', () => {
			this.hideSubNav();
		});

		this.currentMenuItem = this.navMain.querySelector('.menu-item--lev1.current-menu-ancestor');
		this.itemNavigation = this.navMain.querySelectorAll('.menu-item--lev1');

		this.hoverTimeout = 300;
		this.timeoutActive = false;

		this.itemNavigation.forEach( (item) => {

			if( item.classList.contains('menu-item-has-children') ) {
				item.querySelector('a').addEventListener('click', (e) => {
					e.preventDefault();
					this.showSubNav(item);
				});
			}

			item.addEventListener('mouseenter', (e) => {

				e.stopPropagation();

				if (this.timeoutActive && !item.classList.contains('current-menu-ancestor') && this.currentMenuItem) {

					clearTimeout(this.leaveTimeout);
					clearTimeout(this.enterTimeout);

					this.enterTimeout = setTimeout(() => {
						if( this.currentMenuItem.classList.contains('show-child') ) {
							let event = new MouseEvent('customEventLeave');
							this.currentMenuItem.dispatchEvent(event);
						}
						this.currentMenuItem.classList.remove('show-child');
					}, this.hoverTimeout);

				} else if( !item.classList.contains('current-menu-ancestor') && this.currentMenuItem ) {

					this.currentMenuItem.classList.remove('show-child');
					let event = new MouseEvent('customEventLeave');
					this.currentMenuItem.dispatchEvent(event);

				}

				if( !mobileCheck.isMobile ) {
					let event = new MouseEvent('customEventEnter');
					item.dispatchEvent(event);
				}

			});

			item.addEventListener('mouseleave', (e) => {

				e.stopPropagation();
				this.timeoutActive = true;
				this.leaveTimeout = setTimeout(() => {

					if( this.currentMenuItem ) {
						this.currentMenuItem.classList.add('show-child');
						if (!item.classList.contains('current-menu-ancestor')) {
							let event = new MouseEvent('customEventEnter');
							this.currentMenuItem.dispatchEvent(event);
						}
					}

					this.timeoutActive = false;
				}, this.hoverTimeout);

				if (!item.classList.contains('current-menu-ancestor')) {
					let event = new MouseEvent('customEventLeave');
					item.dispatchEvent(event);
				}

			});

		});
	}

	showSubNav(item){
		item.closest('.menu-item').classList.add('show-child');
		this.navMain.classList.add('subnav-open');
	}

	hideSubNav(){
		let item = this.navMain.querySelector('.show-child');
		if(item){
			item.closest('.menu-item').classList.remove('show-child');
		}
		this.navMain.classList.remove('subnav-open');
	}

	showHideNavMain(){

		ScrollTrigger.create({
			start: window.innerHeight / 3,
			end: 99999,
			onToggle: (self) => {
				document.body.classList.toggle('nav-main-hide', self.isActive);
			}
		});

		let sectionWhite = document.querySelectorAll('.section.section-dark-green, .section.section-texture');
		let logo = document.querySelector('.header-logo');
		let logoPos = logo.getBoundingClientRect();

		sectionWhite.forEach( (section) => {
			ScrollTrigger.create({
				trigger: section,
				start: "top top+=" + logoPos.top,
				end: "bottom top+=" + logoPos.top,
				onToggle: (self) => {
					document.body.classList.toggle('nav-main-light', self.isActive);
				}
			});
		});

		let blockDark = document.querySelectorAll('.block-image-background-text');
		blockDark.forEach( (block) => {
			ScrollTrigger.create({
				trigger: block,
				start: "top top+=" + logoPos.top,
				end: "bottom top+=" + logoPos.top,
				onToggle: (self) => {
					document.body.classList.toggle('nav-main-dark', !self.isActive);
				}
			});
		});

	}

}